import { useState, useEffect } from 'react'
import { ShieldCheck, X } from 'lucide-react'
import { Button } from '@/components/ui/button'

export function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    // Verifica se o usuário já tomou uma decisão sobre os cookies
    const consent = localStorage.getItem('lgpd_cookie_consent')
    if (!consent) {
      // Pequeno delay para uma aparição suave
      const timer = setTimeout(() => {
        setIsVisible(true)
      }, 1500)
      return () => clearTimeout(timer)
    }
  }, [])

  const handleAcceptAll = () => {
    localStorage.setItem('lgpd_cookie_consent', 'accepted_all')
    setIsVisible(false)
  }

  const handleAcceptEssential = () => {
    localStorage.setItem('lgpd_cookie_consent', 'accepted_essential')
    setIsVisible(false)
  }

  if (!isVisible) return null

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:max-w-md bg-slate-900 border border-slate-800 text-slate-100 p-5 rounded-2xl shadow-2xl z-[9999] transition-all duration-300 ease-in-out flex flex-col gap-4 animate-in slide-in-from-bottom-5">
      <div className="flex items-start gap-3">
        <div className="p-2 bg-blue-500/10 text-blue-400 rounded-xl shrink-0">
          <ShieldCheck size={20} />
        </div>
        <div className="flex-1 space-y-1">
          <h4 className="font-bold text-sm text-white">Privacidade e Cookies (LGPD)</h4>
          <p className="text-xs text-slate-400 leading-relaxed">
            Utilizamos cookies essenciais para o funcionamento seguro da plataforma e analíticos para melhorar sua experiência. Ao continuar, você concorda com nossa{' '}
            <a 
              href="/privacidade.html" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-blue-400 hover:underline font-semibold"
            >
              Política de Privacidade
            </a>.
          </p>
        </div>
        <button 
          onClick={handleAcceptEssential} 
          className="text-slate-500 hover:text-slate-300 transition-colors p-1"
          title="Fechar"
        >
          <X size={16} />
        </button>
      </div>

      <div className="flex gap-2.5 justify-end">
        <Button 
          variant="ghost" 
          size="sm" 
          onClick={handleAcceptEssential}
          className="text-xs text-slate-400 hover:text-white hover:bg-slate-800 font-medium"
        >
          Apenas essenciais
        </Button>
        <Button 
          size="sm" 
          onClick={handleAcceptAll}
          className="text-xs bg-blue-600 hover:bg-blue-700 text-white font-semibold px-4"
        >
          Aceitar tudo
        </Button>
      </div>
    </div>
  )
}
